import { render, staticRenderFns } from "./PaymentDashboardContent.vue?vue&type=template&id=b1ca0a58&"
import script from "./PaymentDashboardContent.vue?vue&type=script&lang=js&"
export * from "./PaymentDashboardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports